module.exports = __webpack_public_path__ + "static/media/search.8f48dd6c.svg";